import { defineComponent as l, ref as m, onMounted as a } from "vue";
import f from "./index603.js";
import u from "./index170.js";
import d from "./index37.js";
import { MsClose as S } from "@sunrise/icons";
import { screenSizeDetection as p } from "@sunrise/shared";
import { throttle as g } from "lodash-es";
const h = 0.2, k = l({
  name: "HydratedQuestionStarSticky",
  components: {
    MsHeadline: u,
    SurveySvg: f,
    CsPrimaryButton: d,
    MsClose: S
  },
  props: {
    href: String,
    rel: String,
    target: String,
    headline: String,
    text: String,
    linkText: String
  },
  setup() {
    const { isScreenM: o } = p(), t = m(!1), e = g(n, 200);
    a(() => document.addEventListener("scroll", e));
    function n() {
      t.value = r(), t.value && document.removeEventListener("scroll", e);
    }
    function r() {
      const { top: s, height: c } = document.body.getBoundingClientRect();
      return Math.abs(s) / c > h;
    }
    function i() {
      t.value = !1;
    }
    return {
      isVisible: t,
      onClick: i,
      isScreenM: o
    };
  }
});
export {
  k as default
};
